// @flow

import {fabric} from 'fabric';

import {getIdealCanvasDimensions} from '../utils';
import {StateManager, type State} from './state-manager';

import colors from '../colors';
import {type FabricImage} from '../types';

export class CanvasManager {
  canvas: any;
  img: fabric.Image;
  stateManager = new StateManager();

  constructor(canvasElement: HTMLCanvasElement) {
    this.canvas = new fabric.Canvas(canvasElement, {width: 1, height: 1});
    this.canvas.centeredRotation = false;

    // adds keyboard listening for 'del' key to remove selected objects
    var el = this.canvas.upperCanvasEl;
    var _canvas = this.canvas;
    el.setAttribute('tabIndex', 1);
    el.addEventListener('keydown', function (e) {
      if (e.code == 'Delete' || e.code == 'Backspace') {
        // remove whomeever is selected.
        var selected = _canvas.getActiveObjects();
        for (var i = 0; i < selected.length; i++) {
          _canvas.remove(selected[i]);
        }
        _canvas.renderAll();
      }
    });

    this.canvas.on('object:selected', function (e) {
      e.target.transparentCorners = false;
      e.target.borderColor = colors.selectedObject.borderColor;
      e.target.cornerColor = colors.selectedObject.cornerColor;
      e.target.cornerStyle = 'circle';
    });
  }

  setImage(image: FabricImage) {
    this.img = image;
    this.img.selectable = false;
    this.canvas.add(this.img);
    this.canvas.renderAll();
    this.saveState();
  }

  updateCanvasSize = () => {
    if (this.img != null) {
      const imgDimensions = this.img.getBoundingRect(true, true);
      const dimensions = getIdealCanvasDimensions(imgDimensions);
      const zoom = dimensions.width / imgDimensions.width;

      this.canvas.setDimensions(dimensions);
      this.canvas.setZoom(zoom);
    }
  };

  saveState = () => {
    const serialized = this.canvas.toJSON();
    this.stateManager.addState(serialized);
    this.updateCanvasSize();
  };

  restoreState(state: State) {
    this.canvas.loadFromJSON(state, () => {
      this.img = this.canvas.item(0);
      this.img.selectable = false;
      this.updateCanvasSize();
      this.canvas.renderAll();
    });
  }

  selectAll() {
    this.canvas.discardActiveObject();

    const activeObject = new fabric.ActiveSelection(this.canvas.getObjects(), {
      canvas: this.canvas,
    });
    this.canvas.setActiveObject(activeObject);
    return activeObject;
  }

  undo() {
    this.restoreState(this.stateManager.reverseState());
  }

  redo() {
    this.restoreState(this.stateManager.forwardState());
  }
}
